import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ApiContext, BACKEND_CONFIG } from '@unicup-ticketing/injection-context';

export interface CoreLoginResult {
  id: string;
}

@Injectable({
  providedIn: 'root',
})
export class IdmService {
  private http = inject(HttpClient);
  private readonly baseUrl: string;

  constructor() {
    const backendConfig = inject<ApiContext>(BACKEND_CONFIG);
    this.baseUrl = backendConfig.baseUrl;
  }

  public login(): Observable<HttpResponse<CoreLoginResult>> {
    return this.http.post<CoreLoginResult>(`${this.baseUrl}/login`, {}, { observe: 'response' });
  }
}
